import { LiveAnnouncer } from '@angular/cdk/a11y';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { ApplicationInfoUserUsanModel, RetrieveUsanUserApplRequest, UserDashboardService } from 'app/user-dashboard/user-dashboard.service';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { UserService } from 'app/users/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-applications-list',
  templateUrl: './user-applications-list.component.html',
  styleUrls: ['./user-applications-list.component.scss']
})
export class UserApplicationsListComponent implements OnInit {
  private user!: UserProfileRecord;
  private mobileDeviceSize: boolean = false;
  private sizeChangeSubscription!: Subscription;
  currentPage = 0;
  paginatedAppl: ApplicationInfoUserUsanModel[] = [];    // Items to show on current page
  pageSize = 10;
  totalItems = 0;
  @ViewChild(MatSort) sort!: MatSort;
  usanUserApplications!: ApplicationInfoUserUsanModel[];
  appTypes: string[] = ['Draft', 'Submitted', 'In Review', 'Approved / Closed'];
  loadingComplete: boolean = false;

  constructor(
     private responsive: BreakpointObserver,
     private router: Router,
     private sortAnnouncer: LiveAnnouncer,
      protected userService: UserService,
      private userDashboardService: UserDashboardService,)
  { }
  ngOnInit() {
    this.user = this.userService.profile;
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
            if(result.matches) {
              this.mobileDeviceSize = true;
            } else {
              this.mobileDeviceSize = false;
            }
          });
    this.retrieveApplications('Draft');
  }
  get applications() {
    return this.usanUserApplications;
  }
  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }
  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }

  viewDetails(element: any) {
    let formTypeStr : string  = element.form  // to remove leading empty space in the form field
    this.router.navigate(['/usan/application'], 
      { queryParams : { formType: formTypeStr.trimStart(), id: element._caseSysId, source: 'user-dashboard'}});
    
  }

  onPageChange(event: PageEvent) {
      this.pageSize = event.pageSize;
      this.currentPage = event.pageIndex;
      this.updatePaginatedItems();
  }
     
  private updatePaginatedItems() {
      const start = this.currentPage * this.pageSize;
      const end = start + this.pageSize;
      this.paginatedAppl = this.usanUserApplications.slice(start, end);
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes['usanUserApplications'] && this.usanUserApplications) {
         this.totalItems = this.usanUserApplications.length;
         this.currentPage = 0; // reset to first page when new data comes inv
         this.updatePaginatedItems();
        }
  }

  sortChangeUpdate(sortChange: Sort) {
      const data = [... this.usanUserApplications];
      let column = sortChange.active;
      let dir = sortChange.direction;
      if (!column || dir === '') {
        //no change
        return;
      }
      const isAsc = dir ==='asc';
      this.usanUserApplications = data.sort((a,b) => {
        let aValue = typeof a[column] === 'string' ? a[column].toLowerCase() : a[column];
        let bValue = typeof b[column] === 'string' ? b[column].toLowerCase() : b[column];
        return this.compareValues(aValue, bValue, isAsc);
  
      });
      this.updatePaginatedItems();
      if(sortChange.direction) { //to announce sorting change for assistive technology
        this.sortAnnouncer.announce('Sorted '+ sortChange.direction);
      } else {
        this.sortAnnouncer.announce('Sort cleared');
      }
    }
    
    compareValues( a: string|number, b: string|number, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
  

  retrieveApplications(appStatus: string) {
    if (this.user.orgId) { 
      const request : RetrieveUsanUserApplRequest = {
        orgId: this.user.orgId ?? '',
        ssoId: this.user.uniqueId ?? '',
        status: [appStatus]
      };
      this.userDashboardService.fetchApplicationsUsanUser(request).subscribe({
        next: (response) => {
          let data = response.Data;
          if (data) {
            this.usanUserApplications = this.userDashboardService.mapToApplicationUserModelArray(data);
          }
          this.currentPage = 0;
          this.totalItems = this.usanUserApplications.length;
          this.updatePaginatedItems();
          this.loadingComplete = true;
        },
        error: (err) => {
          console.log("Fetching Usan User Applications Error - " + err);
          this.loadingComplete = true;
        }
      });
    }
  }
  
  selectAppTypeChange(appType: MatTabChangeEvent) {
    this.loadingComplete = false;
    let appTypeSelected = this.appTypes[appType.index];
    if(appTypeSelected.includes('Approved'))
      appTypeSelected = 'Approved'; //Approved will also include Closed cases as well
    this.retrieveApplications(appTypeSelected);
  }
}
